<template>
  <div style="width: 350px">
    <v-text-field
      :full-width="true"
      flat
      hide-details
      prepend-inner-icon="mdi-magnify"
      label="Shipment#, Phone# or Last Name"
      v-model="searchInput"
      clearable
      @change="search"
      @click:clear="clear"
    ></v-text-field>
  </div>
</template>
<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  props: {},
  data() {
    return {
      searchInput: ""
    };
  },
  methods: {
    phoneRegex() {
      const cleanedInput = this.searchInput.replace(/\D/g, "");
      const regex = new RegExp(cleanedInput.split("").join("[^\\d]*"));
      return regex;
    },
    search() {
      if (!this.searchInput) {
        return;
      }
      var qry = this.$root.getQry(true);
      if (!qry["$or"]) {
        qry["$or"] = [];
      }

      if (isNaN(this.searchInput.trim())) {
        qry["$or"].push({
          "shipment_detail.shipment_number": this.searchInput.trim() || 0
        });
        qry["$or"].push({
          $expr: {
            $eq: [{ $toLower: "$last_name" }, this.searchInput.trim().toLowerCase()]
          }
        });
      } else {
        qry["$or"].push({ shipment_id: parseInt(this.searchInput) });
        qry["$or"].push({
          phone_array: {
            $regex: this.searchInput.trim().replace(/\D/g, "") || 0,
            $options: "i"
          }
        });
      }

      if (!qry["$or"].length) {
        delete qry["$or"];
      }
      if (!qry["$and"].length) {
        delete qry["$and"];
      }
      axios
        .post(
          this.serverURL + "/get_data",
          {
            qry: qry,
            object_name: "shipments",
            schema_name: "v_shipments"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          var data = response.data;
          if (data.model && data.model.length) {
            // data.model[0].shipment_id;
            data.model.forEach(m => {
              this.$root.addResentTab(m);
            });
          }
        });
    },

    clear() {
      this.$root.$router.push({ path: "/shipments" });
    }
  }
};
</script>
